import * as React from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import {Admin} from '../../_models/Admin'
import {themeStyles, customSelectStyles} from '../campaign/themeStyles.js'
import * as controller from './controller'
import { withLocalize, Translate } from "react-localize-redux";

class AdminPage extends React.Component<any, any> {

  handleAdminChange: any
  handleSelectChange: any
  updateAdmin:any
  picture: any

  constructor(props: any) {
    super(props);
    this.state = {
      admin: new Admin(),
      picture: "",
      updating: false,
      privileges: [{
        value: "admin",
        label: this.props.translate("admin.manager").toString()
      }, {
        value: "editor",
        label: this.props.translate("admin.editor").toString()
      }]
    }
    this.updateAdmin = controller.updateAdmin.bind(this)
    this.handleAdminChange = controller.handleAdminChange.bind(this)
  }



  componentDidMount() {
    if(this.props.match.params.id && !isNaN(this.props.match.params.id)) {
      this.loadAdmin(this.props.match.params.id)
    }

  }

  componentWillReceiveProps(nextProps: any) {
    if(nextProps.match.params.id
      && !isNaN(nextProps.match.params.id)
      && this.state.admin.id != nextProps.match.params.id) {
      this.loadAdmin(nextProps.match.params.id)
    } else {
      this.setState({admin: new Admin()})
    }

  }

  selectFile(input: any) {
    let file = this.picture.files[0]
     var reader = new FileReader();
     let admin = this.state.admin
     admin.updated = false
     reader.onload = (e: any) => {
       if(e.target) {
         this.setState({picture: e.target.result, admin})

       }
     }
     reader.readAsDataURL(file);
  }


  loadAdmin(id:any) {
    fetch('admins/get', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(results => {
      return results.json();
    }).then(data => {
        let admin = new Admin(data.admin)
        this.setState({admin})
    }).catch(err => {
      alert(err.message);
    })
  }


  public render() {
    let admin = this.state.admin
    let privilege = admin.privilege && admin.privilege == "admin"? this.props.translate("admin.manager").toString() : this.props.translate("admin.editor").toString()
    let isAdmin = window.account.privilege == "admin"
    let canEdit = window.account.id == admin.id || isAdmin
    let url = this.state.picture.length? this.state.picture : process.env.REACT_APP_AWS+"/admins/"+admin.id+"/pictures/"+admin.picture
    return (
      <div id="edit-account-root">
          <Link to="/admins"><i className="fas fa-times"></i></Link>
          <form className="data">
            {((admin.id && admin.picture.length) || (this.state.picture.length))?
              (<div className="picture" style={{backgroundImage: "url("+url+")"}} onClick={() => {if(canEdit) {this.picture.click()}}}></div>)
            : (<div className="picture" onClick={() => {if(canEdit) {this.picture.click()}}}></div>)}
            <input className="third" readOnly={!canEdit} onChange={this.handleAdminChange} defaultValue={admin.name} name="name" placeholder={this.props.translate("name").toString()} />
            <input className="third" readOnly={!canEdit} onChange={this.handleAdminChange} defaultValue={admin.phone} name="phone" placeholder={this.props.translate("phone").toString()} />
            <input className="third" readOnly={!canEdit} onChange={this.handleAdminChange} defaultValue={admin.email} name="email" placeholder={this.props.translate("email").toString()} />
            <input className="third" readOnly={!canEdit} onChange={this.handleAdminChange} defaultValue={admin.address} name="address" placeholder={this.props.translate("address").toString()} />
            {window.account.id == admin.id && <input type="password" className="third" readOnly={!canEdit} onChange={this.handleAdminChange}  name="password" placeholder={this.props.translate("newPassword").toString()} />}
            <div className="third"><Select
              value={admin.privilege && {value: admin.privilege, label: privilege}}
              onChange={controller.handleSelectChange.bind(this)}
              options={this.state.privileges}
              menuPlacement={"bottom"}
              placeholder={this.props.translate("admin.choosePrivilege").toString()}
              isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
              theme={themeStyles}
              styles={customSelectStyles}
              className="multiSelect"
              classNamePrefix="react-select"
            /></div>
            <input style={{display: "none"}} readOnly={!canEdit} ref={el => this.picture = el} onChange={this.selectFile.bind(this, this.picture)} name="picture" type="file" />
            {canEdit && <div>
            <button className={"update "+((admin.id && admin.updated)? "updated" : "")} onClick={this.updateAdmin} disabled={admin.updated || this.state.updating}>
              {this.state.updating? this.props.translate("updating").toString() :
                admin.id? admin.updated? this.props.translate("updated").toString() :
                this.props.translate("update").toString() :
                this.props.translate("save").toString()}
            </button>
            <button onClick={controller.resetPassword.bind(this, admin.id)} style={{width: "350px"}} className="primary-btn green"><Translate id="resetPasswordAndSend" /></button>
            </div>}
          </form>
        </div>
    )
  }
}

export default withLocalize(AdminPage)



// WEBPACK FOOTER //
// ./src/pages/admin/Admin.tsx